module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Tomek_Ola.25c1205a.jpg";